"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerDashmixDSL = void 0;
const vue_unique_id_1 = __importDefault(require("vue-unique-id"));
const vue_1 = __importDefault(require("vue"));
const composition_api_1 = __importDefault(require("@vue/composition-api"));
const vue_router_1 = __importDefault(require("vue-router"));
const _abstract_1 = require("../_abstract");
const Accordion_1 = require("./Accordion");
const Avatar_1 = require("./Avatar");
const Badge_1 = require("./Badge");
const Box_1 = require("./Box");
const BoxTabs_1 = require("./BoxTabs");
const Breadcrumbs_1 = require("./Breadcrumbs");
const Button_1 = require("./Button");
const Check_1 = require("./Check");
const CheckList_1 = require("./CheckList");
const DateTimePicker_1 = require("./DateTimePicker");
const Dropdown_1 = require("./Dropdown");
const File_1 = require("./File");
const Icon_1 = require("./Icon");
const Input_1 = require("./Input");
const InputGroup_1 = require("./InputGroup");
const Link_1 = require("./Link");
const Modal_1 = require("./Modal");
const NavTabs_1 = require("./NavTabs");
const Pagination_1 = require("./Pagination");
const Select_1 = require("./Select");
const Table_1 = require("./Table");
const TableSearchBar_1 = require("./TableSearchBar");
const TextArea_1 = require("./TextArea");
/**
 * List of all available DSL components.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
const componentsRegistry = {
    Accordion: Accordion_1.DashmixAccordion,
    Avatar: Avatar_1.DashmixAvatar,
    Badge: Badge_1.DashmixBadge,
    Box: Box_1.DashmixBox,
    BoxTabs: BoxTabs_1.DashmixBoxTabs,
    Breadcrumbs: Breadcrumbs_1.DashmixBreadcrumbs,
    Button: Button_1.DashmixButton,
    Check: Check_1.DashmixCheck,
    CheckList: CheckList_1.DashmixCheckList,
    DateTimePicker: DateTimePicker_1.DashmixDateTimePicker,
    Dropdown: Dropdown_1.DashmixDropdown,
    DropdownDivider: Dropdown_1.DashmixDropdownDivider,
    DropdownItem: Dropdown_1.DashmixDropdownItem,
    File: File_1.DashmixFile,
    Icon: Icon_1.DashmixIcon,
    Input: Input_1.DashmixInput,
    InputGroup: InputGroup_1.DashmixInputGroup,
    Link: Link_1.DashmixLink,
    Modal: Modal_1.DashmixModal,
    ModalInner: Modal_1.DashmixModalInner,
    NavTabs: NavTabs_1.DashmixNavTabs,
    Pagination: Pagination_1.DashmixPagination,
    Select: Select_1.DashmixSelect,
    Table: Table_1.DashmixTable,
    TableCell: Table_1.DashmixTableCell,
    TableRow: Table_1.DashmixTableRow,
    TableSearchBar: TableSearchBar_1.DashmixTableSearchBar,
    TextArea: TextArea_1.DashmixTextArea
};
/**
 * Registers the Dashmix DSL in the app.
 *
 * @param [prefix="D"] - The string that should be used to prefix each component's name.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.registerDashmixDSL = (prefix = 'D') => {
    // Firstly, register the Composition API.
    // This line HAS TO come first, before any other plugins.
    vue_1.default.use(composition_api_1.default);
    // Next, register additional plugins required for the Bootstrap DSL to work.
    vue_1.default.use(vue_unique_id_1.default, { uidProperty: 'uniqueId' });
    vue_1.default.use(vue_router_1.default);
    // Finally, register the components.
    for (const [name, component] of Object.entries(componentsRegistry)) {
        _abstract_1.registerComponent(component, `${prefix}${name}`);
    }
};
//# sourceMappingURL=registry.js.map